var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconSort = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4264FD",
  stroke: "#4264FD",
  strokeWidth: 0.4,
  d: "M10.709 8.302a.637.637 0 0 0 .87-.062l2.3-2.553v10.201c0 .336.28.612.622.612a.62.62 0 0 0 .621-.612v-10.2l2.3 2.552c.248.244.622.276.87.062.248-.244.28-.612.063-.856l-3.388-3.732a.582.582 0 0 0-.903 0l-3.418 3.732a.61.61 0 0 0 .063.856ZM2.645 12.535l3.359 3.735c.299.298.672.315.932 0l3.419-3.735a.614.614 0 0 0-.063-.857c-.383-.3-.768-.094-.87.062l-2.3 2.555V4.112A.62.62 0 0 0 6.5 3.5c-.34 0-.622.244-.622.583v10.21l-2.3-2.556c-.248-.245-.622-.277-.87-.062-.248.247-.28.615-.063.86Z"
})));
export default SvgIconSort;